import { render } from "./ProdutosInformacao.vue?vue&type=template&id=281ebcc6&scoped=true"
import script from "./ProdutosInformacao.vue?vue&type=script&lang=js"
export * from "./ProdutosInformacao.vue?vue&type=script&lang=js"

import "./ProdutosInformacao.vue?vue&type=style&index=0&id=281ebcc6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281ebcc6"]])

export default __exports__